import { useState } from 'react';
import { decodeJWT } from 'aws-amplify/auth';
import { getAccountTokenFromLS, useUserIsActive } from '../utils/auth.utils';
import { getAccessTokenTimeout } from '../utils/localStorageAuthUtils.utils';
import { convertFromSecondsToMilliseconds } from '../utils/utils';

export const useUserActivityStatus = () => {
  const [userIsActive, setUserIsActive] = useState(true);
  const timeout = getAccessTokenTimeout();
  useUserIsActive({ setIsNotIdle: setUserIsActive, accessTokenTimeout: timeout });

  return userIsActive;
};

export const isTokenExpired = accountId => {
  if (!accountId) {
    return true;
  }
  const token = getAccountTokenFromLS(accountId);
  if (!token) {
    return true; // Token is considered expired if it's missing
  }

  const { exp } = decodeJWT(token).payload;
  return !!exp && new Date().getTime() >= convertFromSecondsToMilliseconds(exp);
};
